import { useReducer } from 'react';

export interface FormStatusState {
  isLoading: boolean;
  error: string | null;
}

type FormStatusAction = { type: 'START' } | { type: 'SUCCESS' } | { type: 'ERROR'; error: string } | { type: 'RESET' };

const initialState: FormStatusState = {
  isLoading: false,
  error: null,
};

function formStatusReducer(state: FormStatusState, action: FormStatusAction): FormStatusState {
  switch (action.type) {
    case 'START':
      return { isLoading: true, error: null };
    case 'SUCCESS':
      return { isLoading: false, error: null };
    case 'ERROR':
      return { isLoading: false, error: action.error };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

/**
 * Custom hook for managing form status (loading, error).
 * @returns [state, dispatch]
 */
export function useFormStatusReducer() {
  return useReducer(formStatusReducer, initialState);
}
